import type { Envelope, Job, Milestones, Overview } from "./types";

const now = new Date().toISOString();
export const demoMilestones: Milestones = {
  mode: "milestones",
  active_rules: [{
    rule_id: "ypp-full-current", tier: "full", effective_from: "2023-02-01", effective_until: "2027-02-01",
    subscribers_target: 1000, watch_hours_target: 4000, shorts_views_target: 10_000_000,
    source_url: "https://support.google.com/youtube/answer/72851"
  }],
  upcoming_rules: [{
    rule_id: "ypp-full-2027", tier: "full", effective_from: "2027-02-01", subscribers_target: 1000,
    watch_hours_target: 8000, shorts_views_target: 20_000_000,
    source_url: "https://support.google.com/youtube/answer/12843009"
  }],
  studio_values: { qualified_watch_hours: { value: 684, effective_date: "2026-08-20", entered_at: now, note: "Studio Earn" } },
  estimate: { subscribers: 327, watch_hours_12mo: 712, total_views: 128_430, shorts: 43 },
  custom: [
    { milestone_id: "1", metric: "subscribers", title: "First 500 subscribers", target_value: 500, target_date: "2026-12-01" },
    { milestone_id: "2", metric: "uploads", title: "Publish 100 field notes", target_value: 100 }
  ],
  source_note: "YouTube Analytics values are estimates; Studio Earn values are authoritative."
};

export const demoJobs: Job[] = [
  { job_id: "active", video_id: "2026-08-23-dark-matter-map", kind: "scheduled", status: "running", requested_by: "scheduler", requested_at: now, started_at: now, current_stage: "visuals" },
  { job_id: "done", video_id: "2026-08-22-the-boring-billion", kind: "scheduled", status: "completed", requested_by: "scheduler", requested_at: "2026-08-22T15:00:00Z", finished_at: "2026-08-22T15:18:00Z", current_stage: "youtube_upload" },
  { job_id: "failed", video_id: "2026-08-21-hycean-worlds", kind: "recovery", status: "failed", requested_by: "scheduler", requested_at: "2026-08-21T15:00:00Z", error_code: "YOUTUBE_AUTH" }
];

export const demoOverview: Envelope<Overview> = {
  schema_version: 1, generated_at: now, source_timestamp: now, source: "live", resource_version: 1,
  data: {
    agent: { online: true, shadow_mode: true }, active_job: demoJobs[0], recent_job: demoJobs[1],
    scheduler: { paused: 0, timezone: "America/Denver", version: 3 },
    analytics: { captured_at: now, payload: demoMilestones.estimate }, milestones: demoMilestones
  }
};

export const demoEnvelope = <T,>(data: T): Envelope<T> => ({
  schema_version: 1, generated_at: now, source_timestamp: now, source: "live", resource_version: 1, data
});

